<template>
<div :class="classNames">
  <template v-if="section.has_media">
    <div class="media" :class="section.media.type">
    <template v-if="section.media.type == 'embed'">
      <vue-embedplayer :media="section.media" :current="mediaPlaying"></vue-embedplayer>
    </template>
    <template v-if="section.media.type == 'video'">
      <vue-videoplayer :media="section.media" :current="mediaPlaying"></vue-videoplayer>
    </template>
    <template v-if="section.media.type == 'audio'">
      <vue-audioplayer :media="section.media" :current="mediaPlaying"></vue-audioplayer>
    </template>
  </div>
  </template>
  <template v-if="section.hasImages">
    <div class="pictures" :class="section.imageClasses">
      <template v-for="(img,imgIndex) in section.images">
        <figure :class="'fig-'+imgIndex" :key="imgIndex">
          <vue-flexpic :imgset="img" :sizes="sizes" :aspect="img.aspect" :className="img.attributes.className"></vue-flexpic>
          <figcaption v-if="img.attributes.title">{{img.attributes.title}}</figcaption>
        </figure>
      </template>
    </div>
  </template>
  <template v-if="section.type == 'quote'">
    <blockquote v-if="section.text" class="text" v-html="section.text"></blockquote>
    <h4 class="author">{{section.title}}</h4>
  </template>
  <template v-else>
    <h4 v-if="section.title" class="subtitle">{{section.title}}</h4>
    <div v-if="section.text" class="text" v-html="section.text"></div>
  </template>
</div>
</template>
<script>

import VueFlexpic from './VueFlexpic.vue'
import VuePicture from './VuePicture.vue'
import VueEmbedplayer from './VueEmbedplayer.vue'
import VueVideoplayer from './VueVideoplayer.vue'
import VueAudioplayer from './VueAudioplayer.vue'

export default {
  props: {
    section: {
      type: Object,
      default: function () {
        return {
          type: 'none',
          has_media: false,
          hasImages: false,
          images: [],
          title: '',
          text: '',
          media: {}
        }
      }
    },
    index: {
      type: Number,
      default: 0
    },
    sizes: {}
  },
  data: function () {
    return {
      mediaPlaying: '',
      classNames: []
    }
  },
  created: function () {
    this.mediaPlaying = this.$parent.mediaPlaying
    this.classNames = ['section','section-'+ this.index, this.section.type.toLowerCase().replace(/_/g,'-')]
  },
  components: {
    VuePicture,
    VueFlexpic,
    VueEmbedplayer,
    VueVideoplayer,
    VueAudioplayer
  }
}
</script>


// WEBPACK FOOTER //
// Paragraph.vue?4009ccc2